module.exports = __webpack_public_path__ + "static/media/bg.63dcf76d.png";